/**
 * @author       justin.jeong@zumper.com (Justin Jeong)
 * @copyright    Copyright (c) 2020, Zumper
 */

import { PAGE_NAMES, PROP_NAMES } from '@zcode/mixpanel'
import type { Origin } from '@zcode/nr-utils'
import { memoMapDispatchToProps } from '@zcode/react-utils'
import type { Listable, MaybeEmptyProperty, Property, State } from '@zcode/state-type'
import { connect } from 'react-redux'
import type { Dispatch } from 'redux'
import { selectEntity } from '../../modules/detail/modules/entity/selectors/index'
import { mixpanelShortTermClickOut } from '../../modules/mixpanel/thunks/mixpanelShortTermClickOut'
import { trackShortTermClickout } from '../../modules/tracking/thunks/trackShortTermClickout'
import { ExternalMessageButton } from './ExternalMessageButton'

interface ExternalMessageButtonContainerProps {
  entity?: Listable | Property
  origin: Origin
}

export const mapStateToProps = (state: State, ownProps: ExternalMessageButtonContainerProps) => {
  const { isShortTermFeed } = ownProps.entity || selectEntity(state) || {}
  return {
    isShortTermFeed,
  }
}

const mapDispatchToProps = (dispatch: Dispatch, ownProps: ExternalMessageButtonContainerProps) => {
  return {
    onCtaClick: () => {
      dispatch((_, getState) => {
        const state = getState()
        const entity: MaybeEmptyProperty | Listable = ownProps.entity || selectEntity(state) || {}
        const origin = ownProps.origin
        dispatch(trackShortTermClickout({ entity, origin }))
        dispatch(
          mixpanelShortTermClickOut({
            entity,
            origin: 'booknow',
            extraPayload: {
              [PROP_NAMES.PAGE_NAME]: PAGE_NAMES.MEDIA,
            },
          })
        )
      })
    },
  }
}

const shallowEqualProps = ['entity'] as ['entity']
const equalProps = ['origin'] as ['origin']

export const memoMapExternalMsgBtnDispatchToProps = memoMapDispatchToProps(
  mapDispatchToProps,
  equalProps,
  shallowEqualProps
)

export const ExternalMessageButtonContainer = connect(
  mapStateToProps,
  memoMapExternalMsgBtnDispatchToProps,
  null,
  { forwardRef: true }
)(ExternalMessageButton)
